
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-shared-inbox",
      function () {
        return require("private-next-pages/whatsapp-shared-inbox.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-shared-inbox"])
      });
    }
  